<template>
  <div class="search-results">
    <template v-if="!resultsStore.resultsLoading">
      <p v-if="searchWasNotStarted" class="search-results__text">
        Для поиска девушек выберите нужные параметры и нажмите кнопку "Искать".
      </p>
      <p v-if="resultsIsEmpty" class="search-results__text">
        По вашему запросу ничего не найдено
      </p>
      <template v-if="!searchWasNotStarted">
        <ListCards
            :list="getSlicedCards"
        />
        <pButton
            v-if="showButtonMore"
            class="search-results__show-more"
            @click="step++"
        >
          Показать еще
        </pButton>
      </template>
    </template>

    <div v-if="resultsStore.resultsLoading" class="search-results__loading loading">
      <SpinnerIcon class="loading__icon" />
      <span class="loading__text">Ищем подходящие анкеты ...</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import ListCards from "@/searchSection/components/SearchResults/ListCards.vue";
import { computed, ComputedRef, Ref, ref } from "vue"
import SpinnerIcon from "@/common/icons/SpinnerIcon.vue";
import pButton from '@/common/pButton/pButton.vue'
import { useResultsStore } from "@/searchSection/store/resultsStore";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";

const resultsStore = useResultsStore()
const step: Ref<number> = ref(1)
const countOnStep: number = 10

const searchWasNotStarted = computed(() => resultsStore.results === null)
const resultsIsEmpty = computed(() => resultsStore.results?.length === 0)
const getSlicedCards: ComputedRef<ProfileCardInterface[]> = computed(() => {
  if (resultsStore.results === null) {
    return []
  }
  return resultsStore.results.slice(0, step.value * countOnStep)
})
const showButtonMore: ComputedRef<boolean> = computed(() => {
  if (resultsIsEmpty.value) {
    return false
  }
  
  return Math.ceil((resultsStore.results ? resultsStore.results.length : 1) / countOnStep) !== step.value
})
</script>

<style scoped lang="scss">
.search-results {
  padding: 30px 0;

  &__text {
    text-align: center;
    font-weight: bold;
    font-family: "Inter", sans-serif;
    padding: 30px 0;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    line-height: 32px;
    font-weight: 600;

    &__icon {
      animation: rotation 1.5s linear infinite;
      margin-right: 24px;
    }
  }

  &__show-more {
    font-weight: bold;
    margin: 20px auto;
  }
}
</style>